export class PhoneNumber {
  public context = "";
  public areaCode = "";
  public number = "";

  public constructor(public id: number) {}
}
